import PhoneRinging from '../../src/legacy/PhoneRinging';
export default PhoneRinging;
